<template>
  <div class="d-flex flex-column ga-5 w-100">
    <form
      v-if="siteUrl && externalPagePath"
      class="w-100"
      method="post"
      target="_blank"
      :action="externalPagePath"
    >
      <input
        type="hidden"
        name="csrfmiddlewaretoken"
        :value="context.csrf_token"
      >
      <input
        type="hidden"
        name="domain"
        :value="siteUrl"
      >
      <input
        type="hidden"
        name="url"
        :value="siteUrl"
      >
      <button
        class="information-actions__button d-flex align-center justify-center ga-2 bg-gray-40 rounded-10 px-2 py-4 w-100 text-subtitle-1 text--text"
        type="submit"
        data-qa="lpu_information_site"
      >
        <span class="ui-icon-site ui-icon-fz-big flex-shrink-0" />
        {{ tStatic('Официальный сайт') }}
      </button>
    </form>

    <button
      v-if="licenseItems.length"
      type="button"
      class="information-actions__button d-flex align-center justify-center ga-2 bg-gray-40 rounded-10 px-2 py-4 w-100 text-subtitle-1 text--text"
      data-qa="lpu_information_license"
      @click="openLicense"
    >
      <span class="ui-icon-icon-document-text ui-icon-fz-big flex-shrink-0" />
      {{ tStatic('Лицензия') }}
    </button>

    <CoreImageLightbox
      ref="lightboxRef"
      :items="licenseItems"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import CoreImageLightbox from 'src/core/CoreImageLightbox/CoreImageLightbox.vue'
import type { CoreImageLightboxItem } from 'src/core/CoreImageLightbox/types'
import type { CommonContextStore } from 'src/types/context'
import useContextStore from 'src/store/useContextStore'
import useURLStore from 'src/store/useURLStore'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'

type LightboxExpose = {
  open: (_index: number) => void
}

withDefaults(defineProps<{
  siteUrl?: string
  licenseItems?: CoreImageLightboxItem[]
}>(), {
  siteUrl: '',
  licenseItems: () => [],
})

const { context }: CommonContextStore = useContextStore()
const { reverse } = useURLStore()
const lightboxRef = ref<LightboxExpose | null>(null)
const externalPagePath = computed(() => (
  reverse({ name: 'to_external_page' }) || '/leave/'
))

function openLicense() {
  lightboxRef.value?.open(0)
}
</script>

<style scoped lang="scss">
.information-actions__button {
  border: 0;
  cursor: pointer;
}
</style>
